import React, { Fragment, useEffect } from "react";
import Hero from "../components/Hero";
import Content from "../components/Content";
import Dashboard from "./Dashboard";
import { useAuth0 } from "@auth0/auth0-react";
import EmailVerify from "../components/EmailVerify";

const Home = () => {
  const {
    user,
    isAuthenticated,
      logout
  } = useAuth0();
  useEffect(() => {
    const wasOnEmailVerify = sessionStorage.getItem("email_verification_page");

    if (wasOnEmailVerify && isAuthenticated) {
      console.log("User refreshed on EmailVerify, logging out...");
      setTimeout(() => {
        sessionStorage.removeItem("email_verification_page");
        logout({
          logoutParams: {
            returnTo: window.location.origin,
          }
        });
      },10000);
    }
  }, [isAuthenticated, logout]);

  if (isAuthenticated && !user.email_verified) {
    return(
      <Fragment>
        <EmailVerify></EmailVerify>
      </Fragment>
    )
  }

  // App redirects unauthenticated users to the Auth0 login
  if (!isAuthenticated) return null;

  return (
    <Fragment>
      <Dashboard />
    </Fragment>
  )
};

export default Home;
